package com.mgacreative.hotelru.feature.hotel.ui.components

import androidx.compose.foundation.Image
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.layout.ContentScale

@Composable
expect fun appLogoPainter(isDark: Boolean = false): Painter

@Composable
expect fun hotelHeroPainter(): Painter

@Composable
fun AppLogo(
    modifier: Modifier = Modifier,
    isDark: Boolean = false
) {
    Image(
        painter = appLogoPainter(isDark),
        contentDescription = "App Logo",
        modifier = modifier,
        contentScale = ContentScale.Fit
    )
}
